import {FC, PropsWithChildren} from "react";
import {styled} from "@mui/material/styles";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";

type LayoutProps = PropsWithChildren

const StyledOuterContainer = styled(Container)(({theme}) => ({
    transition: `${theme.transitions.create(['background'], {
        duration: theme.transitions.duration.standard,
    })}`,
    background: theme.palette.background.default,
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 0,
    margin:0,
}))

const StyledPageContainer = styled(Container)(({theme}) => ({
    transition: `${theme.transitions.create(['background'], {
        duration: theme.transitions.duration.standard,
    })}`,
    background: theme.palette.background.paper,
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.2)',
    width: '100%',
    maxWidth: 600,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    minHeight: '100vh',
    overflow: 'hidden',
}))

const StyledContentContainer = styled(Container)({
    padding: '30px 10px',
    flex: 1,
    textAlign: 'center',
})

const Footer = styled(Box)({
    textAlign: 'center',
    padding: 10,
    fontSize: '0.9rem',
    color: '#6c757d',
})

const Layout: FC<LayoutProps> = ({children}) => (
    <>
        <CssBaseline />
        <StyledOuterContainer maxWidth={false} disableGutters>
            <StyledPageContainer maxWidth="md">
                <StyledContentContainer maxWidth={false} disableGutters>
                    {children}
                </StyledContentContainer>
                <Footer>
                    &copy; 2025 Overleven! All Rights Reserved.
                </Footer>
            </StyledPageContainer>
        </StyledOuterContainer>
    </>
)

export default Layout;
